import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyDgk_H_m_bIkEfseaw49p9w5_ofnYRSgxo",
    authDomain: "hairzap-suite.firebaseapp.com",
    projectId: "hairzap-suite",
    storageBucket: "hairzap-suite.firebasestorage.app",
    messagingSenderId: "599615901718",
    appId: "1:599615901718:web:c23603653f0fa48d24e537",
    measurementId: "G-HXR0JLRN2R"
  };

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }